import React from "react";
import { Grid2, Typography, Box, Skeleton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DeviceCard from "./DeviceCard";

const DeviceCardGrid = ({
  devices,
  selectedDevices,
  onSelectDevice,
  isLoading,
}) => {
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <Grid2 container spacing={3}>
        {[1, 2, 3, 4].map((i) => (
          <Grid2 key={i} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <Skeleton variant="rounded" height={180} />
          </Grid2>
        ))}
      </Grid2>
    );
  }

  if (!devices?.length) {
    return (
      <Box textAlign="center" py={6}>
        <Typography variant="h6" color="text.secondary">
          No devices found
        </Typography>
      </Box>
    );
  }

  return (
    <Grid2 container spacing={3}>
      {devices.map((device) => (
        <Grid2
          key={device.serial_number}
          size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
        >
          <DeviceCard
            device={device}
            isSelected={selectedDevices.includes(device.serial_number)}
            onSelect={() => onSelectDevice(device.serial_number)}
            onClick={() => navigate(`/devices/${device.serial_number}`)}
          />
        </Grid2>
      ))}
    </Grid2>
  );
};

export default DeviceCardGrid;
